export const getImage = ({ images, type }) => images?.[type]?.[0]?.url || '';
